import React, { FunctionComponent } from 'react';

import useTheme from '@gojob/ui-bits/styles/useTheme';
import { GatsbyImageProps } from 'gatsby-plugin-image';

import BackdropImage from '../../BackdropImage';
import CheeryTitle from '../../CheeryTitle';

export type ImageProps = {
  image: {
    alt: string;
    hotspot?: { x?: number; y?: number };
    asset: {
      localFile: {
        childImageSharp: {
          gatsbyImageData: GatsbyImageProps['image'];
        };
      };
    };
  };
  children?: React.ReactNode;
};

const useStyles = () => {
  const { breakpoint, spacing } = useTheme();

  return {
    root: {
      height: spacing(72),
      maxHeight: '50vh',
      [breakpoint.up('md')]: {
        borderRadius: spacing(2),
        overflow: 'hidden',
      },
    },
  };
};

const Image: FunctionComponent<ImageProps> = (props) => {
  const { image, children } = props;

  const { alt, asset, hotspot } = image || {};
  const imageData = asset?.localFile?.childImageSharp?.gatsbyImageData;

  const classes = useStyles();

  return (
    <BackdropImage css={classes.root} alt={alt} hotspot={hotspot} image={imageData}>
      {children && (
        <CheeryTitle as="h3" variant="headline1" color="white">
          {children}
        </CheeryTitle>
      )}
    </BackdropImage>
  );
};

export default Image;
